import React, { FC, ReactNode } from 'react'
import Box, { IBoxProps as MuiBoxProps } from 'transfix-ui/core/Box'
import { DisplayLabel } from '../DisplayLabel'
import { DisplayValue } from '../DisplayValue'

export interface IDisplayProps {
  label?: ReactNode
  children?: ReactNode
  BoxProps?: MuiBoxProps
  /**
   * @default false
   */
  enableCopy?: boolean
}

export const Display: FC<IDisplayProps> = ({
  label,
  children: value,
  BoxProps = {},
  enableCopy = false,
}) => {
  return (
    <Box data-test='Display' pb={2} {...BoxProps}>
      {label && <DisplayLabel>{label}</DisplayLabel>}
      {value && <DisplayValue enableCopy={enableCopy}>{value}</DisplayValue>}
    </Box>
  )
}

export default Display
